import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks";
import { formatCurrency } from '../helpers'
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)
    let isMobile = window.innerWidth < 769;
    const [minValue, setMinValue] = useState(range[0]);
    const [maxValue, setMaxValue] = useState(range[1]);
  
    // useEffect(() => {
    //   let nsTip1;
    //   let nsTip2;
  
    //   if (isMobile) {
    //     nsTip1 = document.querySelectorAll(".ns-handle-1 .ns-tip")[1];
    //     nsTip2 = document.querySelectorAll(".ns-handle-2 .ns-tip")[1];
    //   } else {
    //     nsTip1 = document.querySelector(".ns-handle-1 .ns-tip");
    //     nsTip2 = document.querySelector(".ns-handle-2 .ns-tip");
    //   }
    //   const handleMutation = () => {
    //     if (nsTip1) {
    //       const newValue = parseInt(nsTip1.textContent, 10);
    //       console.log(newValue)
    //       let formattedMaxValue = newValue;
    //       setMinValue(formattedMaxValue);
    //     }
    //     if (nsTip2) {
    //       const newValue2 = parseInt(nsTip2.textContent, 10);
    //       let formattedMaxValue = newValue2;
    //       setMaxValue(formattedMaxValue);
    //     }
    //   };
    //   const observer = new MutationObserver(handleMutation);
    //   const config = { characterData: true, subtree: true };
  
    //   if (nsTip1) {
    //     observer.observe(nsTip1, config);
    //   }
    //   if (nsTip2) {
    //     observer.observe(nsTip2, config);
    //   }
    //   return () => {
    //     observer.disconnect();
    //   };
    // }, [range[0], range[1]]);

    // console.log(minValue)
    

    return (
        <li class={`ns-sidebar-dropdown Collapsible Collapsible--padded ${active ? "ns-active" : ""}`}>
            <a
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated Collapsible__Button Heading u-h6"
                href="javascript:void(0)"
                aria-expanded={active}
                onClick={() => {
                    setActive(!active)
                }}
            >
                <span>{facet.name}</span>
                <span class="Collapsible__Plus"></span>
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                <RangeSlider id={facet.id} />
                <div class="price-range__input-group">
                    <div class="price-range__input input-prefix text--xsmall flex-shrink-1">
                        <span class="input-prefix__value text--subdued">£</span>
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    </div>
                    <span class="price-range__delimiter text--small">-</span>
                    <div class="price-range__input input-prefix text--xsmall flex-shrink-1">
                        <span class="input-prefix__value text--subdued">£</span>
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                    </div>
                </div>

            </div>
        </li>
    )
}
